import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MAINAPIURL,APPBACKGROUND_COLOR } from '../appsettings.js';
import Footerdiv from "../layout/footer.js";
import Headerdiv from "../layout/header.js";
import { 
  Layout, 
  Typography, 
  Form, 
  Input, 
  Select, 
  Button, 
  Table, 
  Card, 
  Row, 
  Col, 
  Space, 
  Tag,
  theme,
  Popconfirm,
  Breadcrumb
} from 'antd';
import axios from 'axios';
import { AlertError, AlertSuccess } from '../usableclasses.js';

const { Option } = Select;
const { Content } = Layout;

const GrnList = () => {
  const navigate = useNavigate();
  const ApiURL = MAINAPIURL;
  const TOKEN = localStorage.getItem("AUTHCODE");

  const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();

  // State for search form
  const [searchParams, setSearchParams] = useState({
    keyword: '',
    financialYear: '',
    year: '',
    month: '',
    vendor: '',
    status: '',
    sortField: '',
    sortMethod: ''
  });


  const [grnData, setGRNData] = useState([]);
  const [yearList, setYearList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);


  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(5);
  const [totalRecords, setTotalRecords] = useState(0);

 
  const [form] = Form.useForm();

 
  const [financialYears, setFinancialYears] = useState([]);
  const [loadingFinancialYears, setLoadingFinancialYears] = useState(false);
  const [pos, setPOLists] = useState([]);
  const [loadingPos, setloadingPos] = useState(false);

  // Format date helper function
  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString();
    } catch (e) {
      return dateString;
    }
  };

  // Status badge helper
  const getStatusBadge = (status) => {
    switch ((status || '').toUpperCase()) {
      case 'DRAFT':
        return <Tag color="orange">Draft</Tag>;
      case 'PENDING':
        return <Tag color="blue">Pending</Tag>;
      case 'APPROVED':
        return <Tag color="green">Approved</Tag>;
      case 'REJECTED':
        return <Tag color="red">Rejected</Tag>;
      case 'DELETED':
        return <Tag color="red">Deleted</Tag>;
      default:
        return <Tag color="default">{status}</Tag>;
    }
  };


  useEffect(() => {

    let i = 0;
    const currentdate = new Date();
    let currentyear = currentdate.getFullYear();
    var newYearArray = [];
  
    do {
      let incyear = currentyear - i;
      newYearArray.push(incyear.toString());
      i++;
    }
    while (i < 10);
    
    setYearList(newYearArray);

    setGRNData([]);
    setFilteredData([]);
    setTotalRecords(0);
  }, []);


  useEffect(() => {
    const fetchFinancialYears = async () => {
      setLoadingFinancialYears(true);
      try {
        const response = await axios.get(`${ApiURL}/master/financeyear/dropdown`, {
          headers: { SystemAccessToken: TOKEN }
        });
        if (response.data && Array.isArray(response.data)) {
          setFinancialYears(response.data);
        } else {
          
          setFinancialYears([]);
        }
      } catch (error) {
        
        AlertError('Failed to load financial years');
        setFinancialYears([]);
      } finally {
        setLoadingFinancialYears(false);
      }
    };
    fetchFinancialYears();
  }, [ApiURL, TOKEN]);


  useEffect(() => {
    const fetchpos = async () => {
      setloadingPos(true);
      try {
        const response = await axios.get(`${ApiURL}/purchase/poforgrndropdown`, {
          headers: { SystemAccessToken: TOKEN }
        });
        if (response.data && Array.isArray(response.data)) {
          const validpos = response.data.filter(po => po && po.label);
          setPOLists(validpos);
        } else {
          
          setPOLists([]);
        }
      } catch (error) {
        
        AlertError('Failed to load pos');
        setPOLists([]);
      } finally {
        setloadingPos(false);
      }
    };
    fetchpos();
  }, [ApiURL, TOKEN]);

 
  useEffect(() => {
    const defaultParams = {
      keyword: '',
      financialYear: '',
      year: '',
      month: '',
      vendor: '',
      status: 'PENDING',
      sortField: '',
      sortMethod: ''
    };
    handleFilter(defaultParams, 1);
  }, []);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSearchParams((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  
  const handleFilter = async (values, pageNum = 1) => {
    setLoading(true);
    try {
      const requestParams = {
        keyword: values.keyword || '',
        finYear: values.financialYear || '',
        sysYear: values.year || '',
        sysMonth: values.month || '',
        poId: values.vendor || '',
        currentStatus: 'PENDING',
        pageLength: rowsPerPage,
        pageNumber: pageNum,
        orderColumn: values.sortField || '',
        orderBy: values.sortMethod || ''
      };
      
      const response = await axios.post(
        `${ApiURL}/grn/grnlistfilter`, 
        requestParams,
        {
          headers: { SystemAccessToken: TOKEN }
        }
      );
      
      let records = [];
      let total = 0;
      
      if (response.data) {
        
        if (response.data.dataList && Array.isArray(response.data.dataList)) {
          records = response.data.dataList;
          total = response.data.rowcount || records.length;
          
        }
        // Check for direct array response
        else if (Array.isArray(response.data)) {
          records = response.data;
          total = records.length;
        } 
        // Check for records array in response
        else if (response.data.records && Array.isArray(response.data.records)) {
          records = response.data.records;
          total = response.data.totalRecords || records.length;
        }
        // Check for data array in response (common API pattern)
        else if (response.data.data && Array.isArray(response.data.data)) {
          records = response.data.data;
          total = response.data.total || records.length;
        }
        // Check if it's a single object that needs to be wrapped in an array
        else if (response.data.poId && typeof response.data === 'object') {
          records = [response.data];
          total = 1;
        }
        // Handle unexpected formats
        else {
          AlertError("Data Error");
          // Don't clear existing data on error - this might be causing the disappearing data
          if (filteredData.length > 0) {
            return; // Early return to keep existing data
          }
          records = [];
          total = 0;
        }
      }
      
      if (records.length === 0 && filteredData.length > 0) {
       
        return; // Don't update state if we got no records but have existing data
      }
      
      // Make sure records have all required fields with defaults
      const processedRecords = records.map(record => ({
        grnId: record.grnId || '',
        poId: record.poId || '',
        grnReferance: record.grnReferance || '',
        poReferance: record.poReferance || '', 
        finYear: record.finYear || '',
        sysYear: record.sysYear || '',
        sysMonth: record.sysMonth || '',
        createDate: record.createDate || '',
        vendorName: record.vendorName || '',
        vendorBillNo: record.vendorBillNo || '',
        totalCost: record.totalCost || '0.00',
        totalPaid: record.totalPaid || '0.00',
        totalPayable: record.totalPayable || '0.00',
        currentStage: record.currentStage || '',
        createdBy: record.createdBy || '',
        createdDate: record.createdDate || ''
      }));
      
      // Only update if we have records to show
      if (processedRecords.length > 0) {
        setFilteredData(processedRecords);
        setTotalRecords(total);
        setCurrentPage(pageNum);
        setSearchParams(values);
      }
    } catch (error) {
      
      AlertError('Failed to filter goods receives: ' + (error.message || 'Unknown error'));
      // Don't clear existing data on error
      if (filteredData.length === 0) {
        setFilteredData([]);
        setTotalRecords(0);
        setCurrentPage(1);
      }
    } finally {
      setLoading(false);
    }
  };

  // Clear filters function
  const handleClear = () => {
    form.resetFields();
    const defaultParams = {
      keyword: '',
      financialYear: '',
      year: '',
      month: '',
      vendor: '',
      status: 'PENDING',
      sortField: '',
      sortMethod: ''
    };
    setSearchParams(defaultParams);
    handleFilter(defaultParams, 1);
  };


  const handlePageChange = (page, pageSize) => {
    form.validateFields().then(values => {
      handleFilter(values, page);
    });
  };


  const handleViewGRN = (po) => {
    navigate(`/grnview/${po.grnId}`);
  };

  const columns = [
    {
      title: 'GRN Reference',
      dataIndex: 'grnReferance',
      key: 'grnReferance',
      sorter: (a, b) => a.grnReferance?.localeCompare(b.grnReferance || ''),
    },
    {
      title: 'Create Date',
      dataIndex: 'createDate',
      key: 'createDate',
      render: (text) => formatDate(text),
      sorter: (a, b) => new Date(a.createDate || 0) - new Date(b.createDate || 0),
    },
    {
      title: 'Status',
      dataIndex: 'currentStage',
      key: 'currentStage',
      render: (status) => getStatusBadge(status),
      sorter: (a, b) => (a.currentStage || '').localeCompare(b.currentStage || ''),
    },
    {
      title: 'GRN Value',
      dataIndex: 'totalCost',
      key: 'totalCost',
      render: (value) => value ? `${parseFloat(value).toLocaleString()}` : '0.00',
      sorter: (a, b) => parseFloat(a.totalCost || 0) - parseFloat(b.totalCost || 0),
    },
    {
      title: 'Vendor',
      dataIndex: 'vendorName',
      key: 'vendorName',
    },
    {
      title: 'Year',
      dataIndex: 'sysYear',
      key: 'sysYear',
    },
    {
      title: 'Month',
      dataIndex: 'sysMonth',
      key: 'sysMonth',
      render: (month) => {
        const monthNames = [
          'January', 'February', 'March', 'April', 'May', 'June',
          'July', 'August', 'September', 'October', 'November', 'December'
        ];
        if (month && !isNaN(month)) {
          const monthIndex = parseInt(month, 10) - 1;
          return monthNames[monthIndex] || month;
        }
        return month;
      }
    },
    {
      title: 'Vendor Bill No',
      dataIndex: 'vendorBillNo',
      key: 'vendorBillNo',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => {
        const status = (record.currentStage || '').toUpperCase();
        
        return (
          <Space size="small">
            {/* View button not shown for DRAFT status */}
            <Button 
                type="primary" 
                size="small" 
                onClick={() => handleViewGRN(record)}
              >
                View
              </Button>            
          </Space>
        );
      },
    },
  ];

  // Pagination configuration
  const paginationConfig = {
    current: currentPage,
    pageSize: rowsPerPage,
    total: totalRecords,
    onChange: handlePageChange,
    showSizeChanger: false,
    showTotal: (total, range) => `Showing ${range[0]}-${range[1]} of ${total} items`
  };

  return (
    <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
       <Headerdiv />
      <Content style={{ padding: '10px' }}>
         <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Pending GRN List</Breadcrumb.Item>
         </Breadcrumb>
        
          <div style={{ padding: 20, minHeight: '65vh', background: colorBgContainer, borderRadius: borderRadiusLG }}>
              <Space direction="vertical" style={{ width: "100%", padding: "15px" }}>
                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    {/* Search Form */}
                    <Card title="Search GRN" style={{ marginBottom: 16 }}>
                      <Form
                        form={form}
                        name="search_form"
                        layout="vertical"
                        onFinish={handleFilter}
                        initialValues={searchParams}
                      >
                        <Row gutter={[16, 8]}>
                          <Col xs={24} sm={12} md={4}>
                            <Form.Item name="keyword" label="Search Keyword">
                              <Input placeholder="Search..." />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12} md={5}>
                            <Form.Item name="financialYear" label="Financial Year">
                              <Select 
                                placeholder="Select Financial Year" 
                                allowClear
                                loading={loadingFinancialYears}
                              >
                                {financialYears.map(year => (
                                  <Option key={year.id} value={year.name}>
                                    {year.name}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12} md={5}>
                            <Form.Item name="year" label="Year">
                              <Select placeholder="Select Year" allowClear>
                                  {yearList.map((yearinList, index) => (
                                    <Option 
                                      key={yearinList || index} 
                                      value={yearinList || ''}
                                    >
                                      {yearinList || 'Unknown Year'}
                                    </Option>
                                  ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12} md={5}>
                            <Form.Item name="month" label="Month">
                              <Select placeholder="Select Month" allowClear>
                                <Option value="01">January</Option>
                                <Option value="02">February</Option>
                                <Option value="03">March</Option>
                                <Option value="04">April</Option>
                                <Option value="05">May</Option>
                                <Option value="06">June</Option>
                                <Option value="07">July</Option>
                                <Option value="08">August</Option>
                                <Option value="09">September</Option>
                                <Option value="10">October</Option>
                                <Option value="11">November</Option>
                                <Option value="12">December</Option>
                              </Select>
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={[16, 8]}>
                          <Col xs={24} sm={12} md={6}>
                            <Form.Item name="po" label="Po">
                              <Select 
                                placeholder="Select Po" 
                                allowClear
                                loading={loadingPos}
                              >
                                {pos.map((po, index) => (
                                  <Option 
                                    key={po.id || index} 
                                    value={po.id || ''}
                                  >
                                    {po.label || 'Unknown Po'}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12} md={6}>
                            <Form.Item name="sortField" label="Sort By">
                              <Select placeholder="Select Field">
                                <Option value="REFERANCE">GRN Reference</Option>
                                <Option value="CREATED_DATE">Create Date</Option>
                                <Option value="FINANCE_YEAR">Finance Year</Option>
                                <Option value="COST">Total Cost</Option>
                                <Option value="PAID_AMOUNT">Paid Amount</Option>
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12} md={6}>
                            <Form.Item name="sortMethod" label="Sort Order">
                              <Select placeholder="Select Order">
                                <Option value="ASC">Ascending</Option>
                                <Option value="DESC">Descending</Option>
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12} md={6} style={{ display: 'flex', alignItems: 'center' }}>
                            <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
                              <Button type="primary" htmlType="submit">
                                Filter
                              </Button>
                              <Button onClick={handleClear}>
                                Clear
                              </Button>
                            </Space>
                          </Col>
                        </Row>
                      </Form>
                    </Card>

                    {/* Data Table */}
                    <Card title="Pending Grn List">
                      <div style={{ overflowX: 'auto' }}>
                        <Table
                          columns={columns}
                          dataSource={filteredData}
                          pagination={paginationConfig}
                          rowKey="grnId"
                          size="middle"
                          loading={loading}
                          scroll={{ x: 'max-content' }}
                          locale={{
                            emptyText: loading ? 'Loading...' : (
                              <div>
                                <p>No data found</p>
                                
                              </div>
                            )
                          }}
                        />
                      </div>
                    </Card>
                  </Col>
                </Row>
              </Space>
          </div>
        
      </Content>
      <Footerdiv />
    </Layout>
  );
};

export default GrnList;
